import { Banner, BannerDescription } from '@wartek-id/banner'
import { Table } from '@wartek-id/table'

import { SatpenPtkSummaryResponse } from '@/apis/types'

type Props = {
  ptkSummary?: SatpenPtkSummaryResponse
}

export function TabRekapitulasi({ ptkSummary }: Props) {
  return (
    <div className="space-y-16">
      <Table fullWidth rounded headerVariant="subtle" variant="basic" size="sm">
        <thead>
          <tr>
            <th className="w-[150px]">Uraian</th>
            <th className="w-[100px]">Pendidik</th>
            <th className="w-[200px]">Tenaga Kependidikan</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Laki-laki</td>
            <td data-testid="txt-pendidik-lk">
              {ptkSummary?.rekapitulasiPtk?.jumlahGuru?.lakiLaki || '0'}
            </td>
            <td data-testid="txt-tendik-lk">
              {ptkSummary?.rekapitulasiPtk?.jumlahTendik?.lakiLaki || '0'}
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Perempuan</td>
            <td data-testid="txt-pendidik-per">
              {ptkSummary?.rekapitulasiPtk?.jumlahGuru?.perempuan || '0'}
            </td>
            <td data-testid="txt-tendik-per">
              {ptkSummary?.rekapitulasiPtk?.jumlahTendik?.perempuan || '0'}
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>Total</b>
            </td>
            <td>
              <b data-testid="txt-pendidik-total">
                {ptkSummary?.rekapitulasiPtk?.jumlahGuru?.total || '0'}
              </b>
            </td>
            <td>
              <b data-testid="txt-tendik-total">
                {ptkSummary?.rekapitulasiPtk?.jumlahTendik?.total || '0'}
              </b>
            </td>
            <td></td>
          </tr>
        </tbody>
      </Table>
      <Banner title="Keterangan" type="informational" closable={false}>
        <BannerDescription>
          Perhitungan Pendidik dan Tenaga Kependidikan adalah yang sudah
          mendapat penugasan, berstatus aktif dan terdaftar di sekolah induk.
        </BannerDescription>
      </Banner>
    </div>
  )
}
